import React from "react";
import SecondaryContainer from "./SecondaryContainer";
import AboutIntro from "./AboutIntro";
import AboutDraftContent from "./AboutDraftContent";
import XFooter from "./XFooter";
import MainContainer from "./MainContainer";

const Home = () => {
  return (
    <div className="w-full relative">
      <MainContainer />
      <AboutIntro />
      <AboutDraftContent />
      <SecondaryContainer />
      <XFooter />
    </div>
  );
};

export default Home;
